import _ from 'lodash'
import Backbone from 'backbone'
import Dataset from 'scoreboard/datasets/model/dataset'

// this isn't really a view, but it's more convenient to extend than Backbone.Events
const FieldAndGroupRenderer = Backbone.View.extend({

	/**
	 * A generic renderer of fields and field groups.  The fields without any
	 * groups are rendered first, and then the fields with groups are rendered
	 * grouped by field group.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the dataset
	 *
	 * @param {Array} [options.fields] the fields to render.  Defaults to all
	 * the fields in the passed-in Dataset
	 *
	 * @param {Boolean} [options.showVisibleLinkedFields=false] indicates
	 * whether the visible linked fields should be shown
	 */
	initialize: function(options = {}) {
		this.options = options
		this.model = options.model
	},

	/** @type {Dataset} */
	model: null,

	getHtml: function() {
		var groups = this.model.getFieldGroups()
		let fields = _.clone(this.model.attributes.fields)
		if (this.options.showVisibleLinkedFields) {
			fields.push(... _.map(this.model.get('visibleLinkedFields'), vlf =>
				this.model.getVisibleLinkedFieldOption(vlf.id)))
		}
		var fieldsByGroup = _(fields)
			// #16373 always filter the fields to hide any that shouldn't be visible
			.filter(field => this.model.isModifyDataset() || !field.hideFromNonAdmins)
			.sortBy(field => field?.label?.toLowerCase())
			.groupBy('group')
			.value()

		var html = '<tbody>' + this.getFieldsHtml(fieldsByGroup[undefined])
		_.each(groups, (group) => {
			html += this.getGroupHtml(group)
			html += this.getFieldsHtml(fieldsByGroup[group])
		})
		return html + '</tbody>'
	},

	/**
	 * Returns the HTML to render the given fields
	 * @param {Array} fields
	 */
	getFieldsHtml: function(fields) {
		return ''
	},

	/**
	 * Returns the HTML to render the given field group
	 * @param {String} group
	 */
	getGroupHtml: function(group) {
		return ''
	}

})

export default FieldAndGroupRenderer

FieldAndGroupRenderer.__filename__ = 'datasets/field-and-group-renderer.js'
